export default __webpack_public_path__ + "static/media/Avatar.52431325.png";